module.exports = __webpack_public_path__ + "static/home-collaboration1-b239ad8907a5cffdf7ff1d1703fd94ab.png";